// src/utils/constants.js
export const FUNCTION_URL = process.env.REACT_APP_FUNCTION_URL;
export const FUNCTION_KEY = process.env.REACT_APP_FUNCTION_KEY;
export const USER_METADATA_NAMESPACE = process.env.REACT_APP_AUTH0_NAMESPACE;

export const CURRENT_YEAR_STRING = new Date().getFullYear().toString();
export const CSV_DELIMITER = ';';
export const BASE_YEAR_OPTIONS = ["2024", "2025", "all"];

function normalizeFormat(values) {
  if (!Array.isArray(values)) return [];
  return values.map(v => String(v).toLowerCase());
}

function toParameterMap(parameters) {
  const map = {};
  if (!Array.isArray(parameters)) return map;

  // year
  const yearParam = parameters.find(p => p.name?.toLowerCase() === 'year');
  if (yearParam) {
    const allowAll = (yearParam.values || []).some(v => String(v).toLowerCase() === 'all');
    const values = (yearParam.values || []).map(v =>
      allowAll && String(v).toLowerCase() === 'all' ? 'all' : (Number.isFinite(v) ? v : v)
    );
    map.year = {
      values,
      allowAll
    };
  }

  // format
  const formatParam = parameters.find(p => p.name?.toLowerCase() === 'format');
  if (formatParam) {
    map.format = {
      values: normalizeFormat(formatParam.values || ['json', 'csv'])
    };
  }

  return map;
}

function computeRequiresYearAll(parameters) {
  const yearParam = (parameters || []).find(p => p.name?.toLowerCase() === 'year');
  if (!yearParam) return false;
  return (yearParam.values || []).some(v => String(v).toLowerCase() === 'all');
}

/**
 * Transforms the configuration JSON into a map of endpoints.
 * This is now a pure synchronous function that receives the already-loaded config.
 * 
 * @param {Object} configJson - The parsed config.json object
 * @returns {Object} Map of endpoint display names to endpoint configurations
 */
export function transformConfigToEndpoints(configJson) {
  if (!configJson) return {};
  
  const result = {};
  for (const dataset of configJson.datasets || []) {
    for (const endpointGroup of dataset.endpoints || []) {
      const method = (endpointGroup.method || 'get').toLowerCase();
      for (const item of endpointGroup.items || []) {
        const displayName = item.displayName || `${dataset.name}:${item.path}`;
        const parameters = toParameterMap(item.parameters);
        const requiresYearAll = computeRequiresYearAll(item.parameters);
        const endpointCode = item.endpointCode || item.displayName;

        result[displayName] = {
          path: item.path,
          method,
          requiresYearAll,
          endpointCode,
          parameters
        };
      }
    }
  }
  return result;
}